import {
  all,
  fork,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';
import config from '../../../config';
import { performApiPost } from '../../../core/utils/sagaUtils';
import { ApplicationState } from '../../types';
import { openMessageBox } from '../main/actions';
import { requestLoginSession, setLogin, setLoginSession } from './actions';
import {
  LoginAction,
  LoginActionConstants,
  LoginInfo,
  RequestLoginArgs,
} from './types';

function* initializeFlow() {
  yield put(requestLoginSession());
}

function* requestLoginSessionFlow() {
  yield takeEvery(LoginActionConstants.LOGIN_SESSION_REQUEST,
    function* _() {
      const getToken = localStorage.getItem(`site-${config.siteId}-api_token`) || '';
      yield fork((
        token?: string,
      ) => performApiPost<LoginInfo>(
        'v1/Session/GetCurrentLogin', {
          payload: {
            token,
          },
          onResult: ({ result, error }) => put(setLoginSession({
            result,
            error,
          })),
        },
      ),
      getToken);
    });
}

function* setLoginSessionFlow() {
  yield takeEvery(LoginActionConstants.LOGIN_SESSION_SET, function* _() {
    const loginStatus: LoginInfo = yield select(
      (state: ApplicationState) => state.login.loginStatus,
    );

    if (loginStatus?.status === 'success') {
      yield window.authToken = loginStatus.data?.apiToken || undefined;
    }
  });
}

function* requestLoginFlow() {
  yield takeEvery(LoginActionConstants.LOGIN_REQUEST,
    function* _(act: LoginAction<RequestLoginArgs>) {
      yield fork((
        payload,
      ) => performApiPost<LoginInfo>(
        'v1/User/Login', {
          payload,
          onResult: ({ result, error }) => put(setLogin({
            result,
            error,
          })),
        },
      ),
      act);
    });
}

function* setLoginFlow() {
  yield takeEvery(LoginActionConstants.LOGIN_SET, function* _() {
    const loginStatus: LoginInfo = yield select(
      (state: ApplicationState) => state.login.loginStatus,
    );
    if (loginStatus.status === 'success') {
      yield localStorage.setItem(`site-${config.siteId}-api_token`, loginStatus.data?.apiToken!);
    }

    if (loginStatus.status === 'error') {
      yield put(openMessageBox({
        title: 'Login information',
        mode: 'error',
        content: 'Wrong username or password. Please try agian.',
        blurBackdrop: true,
        dismissText: 'OK',
      }));
    }
  });
}

export default function* loginSaga() {
  yield all([
    initializeFlow(),
    requestLoginSessionFlow(),
    setLoginSessionFlow(),
    requestLoginFlow(),
    setLoginFlow(),
  ]);
}
